<h3 mat-dialog-title>Updating {{data.bankAccount.friendlyName}}</h3>
<img (click)="closeDialog()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<form (ngSubmit)="submit()"
      [formGroup]="bankAccountPropertiesForm">
    <mat-dialog-content class="small-content">
        <label>Bank Account Name:</label>
        <input class="form-control form-control-sm"
               formControlName="friendlyName">
    </mat-dialog-content>

    <mat-dialog-actions>
        <button (click)="closeDialog()" [disabled]="sendingUpdate" class="btn btn-outline-secondary">
            Cancel
        </button>
        <button [disabled]="!bankAccountPropertiesForm.valid || sendingUpdate"
                class="btn btn-primary">
            <span *ngIf="!sendingUpdate">Submit</span>
            <ng-container *ngIf="sendingUpdate">
                <i class="fa fa-spinner"></i>
                <span>Submitting</span>
            </ng-container>
        </button>
    </mat-dialog-actions>
</form>
